var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.789,
    height: 18.458,
    viewBox: "0 0 17.789 18.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clip",
    d: "M17.67,7.38a.769.769,0,0,0-1.087,0L8.209,15.791a3.845,3.845,0,1,1-5.437-5.437l8.111-8.144a2.307,2.307,0,1,1,3.262,3.262L6.033,13.616a.786.786,0,0,1-1.087,0,.769.769,0,0,1,0-1.087l7.221-7.254A.769.769,0,1,0,11.08,4.187L3.859,11.442a2.307,2.307,0,0,0,0,3.262,2.363,2.363,0,0,0,3.262,0l8.11-8.145A3.844,3.844,0,1,0,9.795,1.123L1.684,9.267A5.382,5.382,0,0,0,9.3,16.879L17.67,8.471a.769.769,0,0,0,0-1.09Z",
    transform: "translate(-0.108 0.003)",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.9e8fe8f2085b93324f89af98d5c0527a.svg";
export { ForwardRef as ReactComponent };